<template>
  <div>
    <v-container fluid class="lighten-12 content">
      <v-card class="lighten-12 card-content mb-2">
        <v-row class="ma-0 align-right">
          <TableFilters
            :filters="['search', '']"
            v-model="filter"
            :columns="columns"
          ></TableFilters>
        </v-row>
      </v-card>
      <v-card class="lighten-12 card-content mt-0 pa-3">
        <v-col
          class="pr-1 text-right"
          cols="12"
          xs="12"
          sm="6"
          md="2"
          lg="2"
          xl="2"
        >
        </v-col>
        <v-progress-linear
          active="false"
          indeterminate="false"
          :query="false"
          v-if="isLoading"
        ></v-progress-linear>
        <v-data-table
          :fixed-header="true"
          :headers="headers"
          :items-per-page="paginationOptions.perPage"
          :items="EventsDatas"
          class="row-pointer"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          item-key="id"
          hide-default-footer
        >
          <!-- <template v-slot:no-data> </template>
        
          <template v-slot:item.no>
            <v-icon>mdi-vuetify</v-icon>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="px-5">
              <template>
                <AuditLogs :Type="'events'" :Typeid="item.id" />
              </template>
            </td>
          </template> -->
          <template v-slot:item.eventType="{ item }">
            <v-icon>
              {{ item.eventType.icon ? item.eventType.icon : '' }}</v-icon
            >
            {{ item.eventType.name ? item.eventType.name : '' }}
          </template>
          <template v-slot:item.start="{ item }">
            {{ item.start | formatDate }}
          </template>
          <template v-slot:item.end="{ item }">
            {{ item.end | formatDate }}
          </template>
          <template v-slot:item.description="{ item }">
            <span
              style="
                display: block;
                white-space: nowrap;
                width: 12em;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ item.description ? item.description : '...' }}
            </span>
          </template>

          <!-- Action -->
          <template v-slot:item.action="{ item }">
            <list-menu
              feature="event"
              :item="item"
              editPermission="Event Edit"
              @refreshList="refreshData"
              softDeletePermission="Event  Soft Delete"
              viewPermission="Event Show"
            ></list-menu>
          </template>

          <template v-slot:footer>
            <pagination
              url="events"
              @paginationOptions="setPaginationOptions"
              @getPageNumber="setPagenumber"
              :filterAction="true"
              @response="receiveEventsData"
              :filter="filter"
              ref="pagination"
            />
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import TableFilters from '@/components/base/TableFilters';
import pagination from '../shared/components/pagination';
import axios from '@/plugins/axios';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';

export default {
  data: () => ({
    isLoading: false,
    paginationOptions: {},
    EventsDatas: [],

    pagination1: {
      descending: true,
      page: 1,
      expanded: [],
      singleExpand: false,
      total: 0,
      rowsPerPage: 2,
      sortBy: 'fat',
      totalItems: 0,
      rowsPerPageItems: [1, 2, 4, 8, 16],
    },
    pagination: {
      page: 1,
      itemsPerPage: 2,
    },
    page: 1,
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],
    columns: [
      {
        text: 'Title',
        value: 'title',
        show: true,
        disabled: false,
        sortable: false,
      },
      {
        text: 'Type',
        value: 'eventType',
        show: true,
        disabled: false,
        sortable: false,
      },
      {
        text: 'Start',
        value: 'start',
        show: true,
        disabled: false,
        sortable: false,
      },
      {
        text: 'End',
        value: 'end',
        show: true,
        disabled: false,
        sortable: false,
      },

      {
        text: 'All Day',
        value: 'all_day',
        show: true,
        disabled: false,
        sortable: false,
      },
      {
        text: 'Repeat',
        value: 'repeat',
        show: true,
        disabled: false,
        sortable: false,
      },
      {
        text: 'Visibility',
        value: 'visibility',
        show: true,
        disabled: false,
        align: 'center',
        sortable: false,
      },
      {
        text: 'Description',
        value: 'description',
        show: true,
        disabled: false,

        sortable: false,
      },

      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        align: 'center',
        width: '16.5%',
        sortable: false,
      },
    ],

    filter: {
      name: '',
      search: '',
      status: '',
    },
  }),
  computed: {
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },

  components: {
    ValidationProvider,
    ValidationObserver,

    pagination,

    TableFilters,
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },

    clearFilter() {
      this.filter = {};
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    receiveEventsData(data) {
      this.EventsDatas = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
  },
};
</script>
